import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class Language {
    @observable id!: number;

    @observable name!: string;

    @observable code!: string;

    @observable region?: string;

    @observable script?: string;

    @observable codeApi!: string;

    @observable subdomain!: string;

    @observable localeKeyId!: number;

    @observable rtl!: boolean;

    constructor(language?: ModelProperties<Language>) {
        if (language) {
            construct(this, language);
        }
    }
}